import { z } from 'zod';

const priceSchema = z.object({
  from: z.number(),
  currency: z.string(),
});

const areaRangeSchema = z.object({
  from: z.number(),
  to: z.number(),
  unit: z.string(),
});

const officesSchema = z.object({
  areaRange: areaRangeSchema,
  ceilingHeight: z.string(),
  finish: z.array(z.string()),
});

const retailSchema = z.object({
  area: z.object({
    value: z.number(),
    unit: z.string(),
  }),
  price: z.object({
    value: z.number(),
    unit: z.string(),
  }),
  deliveryDate: z.string(),
});

const transportSchema = z.object({
  metro: z.string(),
  parking: z.string().optional(),
});

const AboutObjectSchema = z.object({
  title: z.string(),
  description: z.object({
    text1: z.string(),
    text2: z.string(),
    text3: z.string(),
  }),
  images: z.object({
    url1: z.string().nullable(),
    url2: z.string().nullable(),
  }),
});

const buildingSchema = z.object({
  id: z.string(),
  name: z.string(),
  class: z.object({
    grade: z.string(),
    description: z.string(),
  }),
  direction: z.string(),
  status: z.enum(['in_process', 'completed']),
  developer: z.string(),
  address: z.string(),
  district: z.string(),
  postalCode: z.string(),
  aboutObject: AboutObjectSchema,
  floorPlaning: z.object({
    imageUrl: z.string().nullable(),
    planImages: z.array(z.string()),
    albumLink: z.string(),
  }),
  detailImages: z.array(z.string()),
  coordinates: z.tuple([z.number(), z.number()]),
  floors: z.number(),
  imageUrl: z.string().nullable(),
  specsFirstImageUrl: z.string().nullable(),
  specsSecondImageUrl: z.string().nullable(),
  price: priceSchema,
  yearBuilt: z.number(),
  totalArea: z.object({
    value: z.number(),
    unit: z.string(),
  }),
  offices: officesSchema,
  retail: retailSchema,
  transport: transportSchema,
  available: z.boolean(),
  presentation: z.string().nullable(),
});

export const buildingsSchema = z.array(buildingSchema);
export type buildingType = z.infer<typeof buildingSchema>;

export type filterDataType = {
  direction: string | null;
  price_from: number | null;
  price_to: number | null;
  aria_to: number | null;
  floor_to: number | null;
  parking: boolean;
};
